import { useSelector } from 'react-redux';
import { Text } from '@taxdown/piccolo-web';
import { emailSelector } from 'Store/modules/auth/selectors';
import TabLinks from 'Components/TabLinks';
import Trans from 'Components/Trans';
import * as Styled from './styles';
import { AccountMenuProps } from './types';

const AccountMenu = ({ title, links, children }: AccountMenuProps): JSX.Element => {
  const emailUser = useSelector(emailSelector);
  return (
    <Styled.Container direction="column" gap="dimension_16">
      <Text type="headline" size="M_S_S" color="dark">
        <Trans
          i18nKey={title}
          values={{
            email: emailUser,
          }}
          ns="account"
        />
      </Text>
      <TabLinks links={links} />
      {children}
    </Styled.Container>
  );
};

export default AccountMenu;
